import { useContext, useMemo } from 'react'
import {
  PanelContext,
  RouteContext,
  LocationContext,
  SectionContext,
} from './components'
import { RouteObject } from './types'
import { navigateFactory } from './navigate'
import {
  flattenRoutes,
  renderBranch,
  matchBranchesWithLocation,
} from './helpers'

export function useLocation() {
  return useContext(LocationContext)
}

export function useLocationSoFar() {
  return useContext(RouteContext).locationSoFar || ''
}

export function useCompleteLocationSoFar() {
  return useContext(RouteContext).completeLocationSoFar || ''
}

export function useRoutes(routes: RouteObject[]) {
  const { location: routeLocation, completeLocationSoFar } = useContext(
    RouteContext,
  )

  const location = routeLocation || useLocation()

  const branches = flattenRoutes(routes)
  const matchedBranch = matchBranchesWithLocation(branches, location)

  return matchedBranch
    ? renderBranch(matchedBranch, location, completeLocationSoFar)
    : null
}

export function useNavigate() {
  const { name: panelName } = useContext(PanelContext)
  return useMemo(() => navigateFactory(panelName), [panelName])
}

export function useSectionName() {
  return useContext(SectionContext)?.name
}

export {
  useHistoryCustomBack,
  getRouterValue,
  useSetRouterValue,
  onRouterValueChanged,
} from './utils/hooks'
